module.exports = __webpack_public_path__ + "img/01.e1de491c.png";